import customAxios from "./axios";
import CONFIG from "../../config";

export const getAllJobsByAdditionalPayment = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + "/AdditionalPaymentRequests/GetAllWithFilter", payload)
    .then((res) => {
        let response = res["data"];
        return response;
    });
};